import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { Authorization } from "../../../Context/Authorization";

const EditPermission = ({ permission, onClose }) => {
  const [permissionName, setPermissionName] = useState(
    permission.permissionName || ""
  );
  const [description, setDescription] = useState(permission.description || "");
  const [errors, setErrors] = useState({});
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!permissionName) {
      newErrors.permissionName = "Permission Name is required";
    }
    if (!description) {
      newErrors.description = "Description is required";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }

    const formData = { permissionName, description };

    try {
      const Confiq = Authorization();
      const response = await fetch(
        `${Api}/api/users/permissions/${permission._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json", ...Confiq.headers },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Submitted Successfully");
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="stateForm">
      <Modal show onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Edit Permission</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formPermissionName">
              <Form.Label>Permission Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Permission Name"
                value={permissionName}
                onChange={(e) => setPermissionName(e.target.value)}
                isInvalid={!!errors.permissionName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.permissionName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                isInvalid={!!errors.description}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>

            <Button type="submit">Submit</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditPermission;
